module.exports = __webpack_public_path__ + "img/img_01.9884c625.webp";